import Vue from 'vue';


// 时间过滤，单个字段过滤成两个字段,data:筛选数据，要替换的range字段，目标start字段和目标end字段
function dateFilter({
  data,
  range,
  start,
  end
}) {
  const q = {
    ...data
  }
  if (q.hasOwnProperty(range) && q[range]) {
    q[start] = q[range][0] || '';
    q[end] = q[range][1] || '';
    delete q[range];
  }
  return q
}


/**
 * @description q参数过滤
 * @param {Obejct} 查询的q参数
 * @param {Boolean} 是否处理数组为字符串，默认处理
 * @return {Object} 处理后的参数
 */
const qfilter = function (q, isArrayToString = true) {
  const obj = {};
  for (let key in q) {
    // 数组转成字符串
    if (q[key] instanceof Array && isArrayToString) {
      const str = [...q[key]].join(',');
      if(str !== '')  obj[key] = str;
      continue;
    }
    // 过滤掉空字符串
    if (q[key] !== '') {
      obj[key] = q[key];
    }
  }
  return obj;
}

/**
 * 下载文件**/
const downloadFile = function(href) {
  if (href && (typeof href === 'string')) {
    let a = document.createElement('a');
    a.download = '';
    a.href = href;
    a.click();
    a = null;
  } else {
    this.$message({
      type: 'danger',
      message: '下载地址required',
    });
  }
};



/**
 * 限制输入长度 单位字符**/
const computedStrLen = function (str){
  let len = 0;
  for (let i = 0; i < str.length; i++) {
    let c = str.charCodeAt(i);
    //单字节加1
    if ((c >= 0x0001 && c <= 0x007e) || (0xff60 <= c && c <= 0xff9f)) {
      len++;
    }
    else {
      len += 2;
    }
  }
  return len;
}



// 报表日期过滤
Vue.prototype.$dateFilter = dateFilter;

Vue.prototype.$computedStrLen = computedStrLen;

Vue.prototype.$downloadFile = downloadFile;
